/**
 * SocialFooter — Phase E split (May 6, 2026).
 *
 * Footer of LandingPage: brand icon + copyright + optional social
 * links. Behavior, classes, and conditional rendering byte-identical.
 */
import { BrandIcon } from '@/layout/EOCLogo';
import { SocialLinks } from '@/layout/SocialLinks';

const SocialFooter = ({ companyName, socialLinks, hasSocialLinks }) => (
  <footer className="border-t border-slate-700/50 px-4 sm:px-8 py-6">
    <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        <div className="opacity-50">
          <BrandIcon />
        </div>
        <span className="text-slate-500 text-sm">
          © {new Date().getFullYear()} {companyName || 'All rights reserved'}.
        </span>
      </div>

      {hasSocialLinks && (
        <SocialLinks
          links={socialLinks}
          variant="footer"
          showLabels={true}
        />
      )}
    </div>
  </footer>
);

export default SocialFooter;
